import request from "@/utils/request";
const verifyPhoneNumberCode = async ({ userId, token }) => {
    const data = {
        userId,
        token,
    };
    const result = await request(`${REACT_APP_IDENTITY_SERVER_BASE_URL}/api/account/confirm-phone-number`, {
        method: "POST",
        data,
    });
    if ("error" in result) {
        throw new Error("Invalid code");
    }
    return result.data;
};
export default verifyPhoneNumberCode;
